/*
@author: Nikhil

jvDashboardSettings
======================
Allows you to render a generic settings template using a settings object

Types of fields supported:
============================================================
| objectType |  Component       |       DataType           |
|------------|:----------------:|-------------------------:|
| dropDown   |  jv-select2      |       Single             |
| dropDown   |  jv-ajax-select2 |       Single             |
| dropDown   |  jv-ajax-select  |       SingleRepeated     |
| input      |  input           |       Single             |
============================================================
Usage:
============
<div jv-viewfield viewfield-object="settingsObject"></div>

Steps to create a ajax driven settings dropdown for a viewField object for any widget
a: Make sure to create a name which is the "field.settings.name" for each of the setting and use that as the key in the URL's ,responseKeys , queryParamNames and responseTypeObjects .
b: Create an url entry in the jvViewFieldsConstant.URLs object . This is the endpoint that you will hit to fetch data for your settings dropdown.
c: Add an entry to the jvViewFieldsConstant.responseKeys Object with the same key name that you used in jvViewFieldsConstant.URLs object. This is the keys that the API will have in its response.
d: Add an entry to the jvViewFieldsConstant.queryPanamNames Object with the same key name that you used in jvViewFieldsConstant.URLs and jvViewFieldsConstant.responseKeys  objects incase there are any query params that you may need to send while making this ajax call.
e: Finally you can add an entry to the  responseType object with the same key incase your ajax endpoint returns data in a different format other that a json object . Egstring.
*/
angular.module('jv.Viewfields.Directive', []).factory('jvViewFieldsConstant', ['$jobviteUrls', function($jobviteUrls) {
    return {
        //Make sure the user key is same as the field.settings.name so that field.url can be set to jvViewFieldsConstant.Urls[field.settings.name]
        Urls: {
            "WorkflowSteps": $jobviteUrls.admin + '/action/company/workflowsteps',
            "PostingType": $jobviteUrls.admin + '/action/company/postingtypes',
            "HiringManager": $jobviteUrls.admin + '/action/user/search?&fieldId=-17&applyHMMRestriction=true&pageSize=50&fetchMaxSize=true',
            "Recruiter": $jobviteUrls.admin + '/action/user/search?&fieldId=-16&applyHMMRestriction=true&pageSize=50&fetchMaxSize=true',
            "Company": $jobviteUrls.admin + '/action/company/subsidiaries',
            "Region": $jobviteUrls.admin + '/action/company/regions',
            "Location": $jobviteUrls.admin + '/action/company/locations',
            "Department": $jobviteUrls.admin + '/action/company/departments',
            "Category": $jobviteUrls.admin + '/action/company/categories',
            "RequisitionType": $jobviteUrls.admin + '/action/company/jobtypes',
            "FilterBy": $jobviteUrls.admin + '/action/company/sourcetypenames',
            "SourceType": $jobviteUrls.jhire + '/action/application/sourceTypes',
            "JobStates": $jobviteUrls.admin + '/action/company/JobStates',
        },
        responseKeys: {
            "WorkflowSteps": 'workflowSteps',
            "PostingType": 'postingTypes',
            "Company": 'subsidiaries',
            "Region": 'regions',
            "Location": 'locations',
            "Department": 'departments',
            "Category": 'categories',
            "RequisitionType": 'jobTypes',
            "FilterBy": 'sourceTypeNames',
            "SourceType": 'sourceTypes',
            "HiringManager": 'employees',
            "Recruiter": 'employees',
            "JobStates": 'jobStates',
        },
        queryParamNames: {
            "WorkflowSteps": 'name',
            "PostingType": 'name',
            "Company": 'name',
            "Region": 'name',
            "Location": 'name',
            "Department": 'name',
            "Category": 'name',
            "RequisitionType": 'name',
            "FilterBy": 'name',
            "SourceType": 'name',
            "HiringManager": 'q',
            "Recruiter": 'q',
            "JobStates": 'name',
        },
        responseTypes: {
            "PostingType": 'string'
        }
    };
}]).directive('jvViewfield', ['$http', '$q', '$log', '$timeout', '$window', 'Loading', 'jvDashboardFactory', 'jvViewFieldsConstant', '$rootScope',
    function($http, $q, $log, $timeout, $window, Loading, jvDashboardFactory, jvViewFieldsConstant, $rootScope) {
        //Loops through viewFields and adds a userValues property to each field object
        var massageFieldData = function(vfObject, isSubWidget) {
            angular.forEach(vfObject, function(field, key) {
                var userValueProperty = 'userValues';
                if (angular.isDefined(field.settings) && field.settings.subWidgetSettingValues) {
                    userValueProperty = 'subWidgetSettingUserValues';
                }

                //We need this only to support single select filter types.
                if (!field[userValueProperty] && field.settings && !field.settings.defaultValues && field.settings.viewFieldDataType !=='MultiSelect') {
                    field[userValueProperty] = [{
                            'label': i18n['SELECT_AN_OPTION'],
                        }
                    ];
                }
                if (!field[userValueProperty] && field.settings) {
                    field[userValueProperty] = angular.copy(field.settings.defaultValues);
                }
                //Check for workflow step dropdown type
                if (field.settings && !field.settings.values && field.settings.name && jvViewFieldsConstant.Urls[field.settings.name]) {
                    field.url = jvViewFieldsConstant.Urls[field.settings.name];
                    field.responseKey = jvViewFieldsConstant.responseKeys[field.settings.name];
                    field.queryParamName = jvViewFieldsConstant.queryParamNames[field.settings.name];
                    field.responseType = jvViewFieldsConstant.responseTypes[field.settings.name];
                    /*
                     * The API for fetching the list of hiring managers has the name returned as fullName.
                     * For all current use cases except the hiring manager one, we fetch the name by 'name'
                     */
                    field.name = "name";
                    if (field.settings.name === "HiringManager" || field.settings.name === "Recruiter") {
                        field.name = "fullName";
                    }
                }
                field.canClearOptions = false;
                if (field.settings && !field.settings.defaultValues) {
                    field.canClearOptions = true;
                }

                //For Grouped Settings
                if (field.settings && field.settings.subWidgetSettingValues) {
                    angular.forEach(field.settings.subWidgetSettingValues, function(field, key) {
                        field.label = field.settings.label;
                    });
                    field.settings.subWidgetSettingValues = massageFieldData(field.settings.subWidgetSettingValues, true);
                }

                if (field.subWidgetSettingUserValues) {
                    field.subWidgetSettingUserValues = massageFieldData(field.subWidgetSettingUserValues, true);
                }

                if (field.subWidgetSettingUserValues) {
                    angular.forEach(field.subWidgetSettingUserValues, function(value, key) {
                        if (value.settings) {
                            value.label = value.settings.label;
                        }

                        if (value.subWidgetSettingUserValues) {
                            angular.forEach(value.subWidgetSettingUserValues, function(subValue, key) {
                                if (subValue.settings) {
                                    subValue.label = subValue.settings.label;
                                }
                            })
                        }

                    })
                }
            });
            return vfObject;
        };

        var directiveDefinitionObject = {
            scope: {
                viewfieldObject: '=',
                applySettings: '&',
                selectSettings: '&',
                settingsType: '=',
                sharedObject: '=',
            },

            controller: function($scope, $element) {
                let state = $scope.state = {};
                var viewFields = this;
                if ($scope.sharedObject) {
                    $scope.sharedObject.validationApproved = false;
                }

                $scope.previewlabels = ['Category A', 'Category B', 'Category C'];
                $scope.previewdataseries = [[10,20,30],[20,12,33]];
                $scope.previewdata = [20,12,33];
                $scope.previewSeries = ['Series A', 'Series B', 'Series C'];
                var graphs = ['bar', 'column', 'pie', 'line'];

                $scope.stackedGraph = function(chart) {
                    if (chart && graphs.indexOf(chart.value) !== -1) {
                        return false;
                    }
                    return true;
                }

                $scope.selectChartType = function() {
                    viewFieldArray.field.settings.subWidgetSettingValues[0].userValues[0] = viewFieldArray.field.settings.subWidgetSettingValues[0].settings.values[0];
                }

                $scope.checkValidationSubLevel = function(viewFieldArray) {
                    var userValues = viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].userValues;
                    if (userValues && userValues.length > 0) {
                        $scope.sharedObject.validationApproved = true;
                    } else {
                        $scope.sharedObject.validationApproved = false;
                    }

                    if (userValues && userValues.length > 0) {
                        //Added for HM and posting type. need to fix this.
                        angular.forEach(userValues, function(value, key) {
                            if (!value.fullName) {
                                value.fullName = value.label;
                            }
                        });
                    }
                };

                $scope.isDateField = function(field) {
                    return (field.settings.fieldType === 'Date');
                };

                $scope.checkValidationSubLevelDropDown = function(viewFieldArray, value, id) {
                    viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0]['userValues'+id] = [];
                    //If uservalues is already populated/configured
                    if ((value.settings.name === viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].settingId)
                        && viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].userValues[0]
                        && viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].userValues[0].EId) {
                        viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0]['userValues'+id] = angular.copy(viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].userValues[0]);
                    } else {
                        viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0]['userValues'+id] = angular.copy(value.settings.values[0]);
                        $scope.saveSubLevelDropDown(viewFieldArray, value, id);
                    }
                }

                $scope.saveSubLevelDropDown = function(viewFieldArray, value, id) {
                    if (value.settings.name === viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].settingId) {
                        viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].userValues[0] = angular.copy(viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0]['userValues'+id]);
                    }
                }

                $scope.checkValidation = function(viewFieldArray) {
                    if (viewFieldArray.field.settings.required) {
                        if (viewFieldArray.field.subWidgetSettingUserValues[0]
                            && viewFieldArray.field.subWidgetSettingUserValues[0].settingId
                            && viewFieldArray.field.settings) {
                            //Select first option as default
                            if (!viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].settingId) {
                                viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0] = angular.copy(viewFieldArray.field.subWidgetSettingUserValues[0].settings.subWidgetSettingValues[0]);
                            }
                            if (viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].settings.viewFieldDataType === 'MultiSelect') {
                                $scope.sharedObject.validationApproved = false;
                            } else {
                                $scope.sharedObject.validationApproved = true;
                            }
                        } else {
                            $scope.sharedObject.validationApproved = false;
                        }
                    } else {
                        //Select first option as default
                        if (viewFieldArray.field.subWidgetSettingUserValues[0] && viewFieldArray.field.subWidgetSettingUserValues[0].settingId && !viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].settingId) {
                            viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0] = angular.copy(viewFieldArray.field.subWidgetSettingUserValues[0].settings.subWidgetSettingValues[0]);
                        }
                    }
                    return $scope.sharedObject.validationApproved;
                }

                $scope.initGraphType = function(viewFieldArray, index) {
                    var vfArray = viewFieldArray;
                    if (vfArray.field.subWidgetSettingUserValues[0] && vfArray.field.subWidgetSettingUserValues[0].settingId) {
                        function graphExists(userValueEId) {
                          return vfArray.field.settings.subWidgetSettingValues[index].settings.values.some(function(el) {
                            return el.EId === userValueEId;
                          });
                        }

                        if(!graphExists(vfArray.field.subWidgetSettingUserValues[0].userValues[0].EId)) {
                            vfArray.field.subWidgetSettingUserValues[0].userValues[0] = angular.copy(vfArray.field.settings.subWidgetSettingValues[index].settings.values[0]);
                        }
                    } else {
                        vfArray.field.subWidgetSettingUserValues[0].userValues = [];
                        vfArray.field.subWidgetSettingUserValues[0] = vfArray.field.settings.subWidgetSettingValues[0];
                        vfArray.field.subWidgetSettingUserValues[0].userValues[0] = angular.copy(vfArray.field.settings.subWidgetSettingValues[index].settings.values[0]);
                    }
                }

                $scope.selectGroupByDropdown = function(viewFieldArray, value, id) {
                    $scope.selectGroupBy(viewFieldArray, value);
                    $scope.saveSubLevelDropDown(viewFieldArray, value, id);
                }

                $scope.selectGroupBy = function(viewFieldArray, value) {
                    viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].settings = value.settings;
                    viewFieldArray.field.subWidgetSettingUserValues[0].subWidgetSettingUserValues[0].userValues = [];
                    if (viewFieldArray.field.settings.required) {
                        $scope.sharedObject.validationApproved = true;
                    }
                }

                //Need to watch the viewfieldObject so that the direcitve gets called everytime
                $scope.$watch('viewfieldObject', function(viewfieldObject, oldVal) {
                    //Used to render the fields.
                    $scope.displayFields = [];
                    $scope.displayDataSourceFields = [];
                    if (!($.isEmptyObject(viewfieldObject))) {
                        //init
                        //Copy widget settings array into viewfields
                        $scope.viewFields = angular.copy($scope.viewfieldObject.widgetSetting);
                        //Massage viewFields
                        $scope.viewFields = massageFieldData($scope.viewFields, false);
                        //Render viewFields
                        viewFields.renderfields();
                    }
                }, true);
                //adds a field to fieldtype array
                this.renderField = function(field, key) {
                    var fieldArr = []
                    fieldArr.push({
                        fieldType: field.settings.fieldType,
                        field: field
                    })
                    $scope.displayFields.push(fieldArr);
                };
                this.renderDataSourceField = function(field, key) {
                    var fieldArr = []
                    fieldArr.push({
                        fieldType: field.settings.fieldType || field.settingType,
                        field: field
                    })
                    $scope.displayDataSourceFields.push(fieldArr);
                };
                this.renderfields = function() {
                    angular.forEach($scope.viewFields, function(field, key) {
                        if (field.settingType === 'GroupByLevel1' || field.settingType === 'GroupByLevel2' || field.settingType === 'GraphType') {
                            viewFields.renderDataSourceField(field, key);
                        } else {
                            viewFields.renderField(field, key);
                        }
                    });
                };
                return this;
            },
            link: function(scope, iElm, iAttrs, ngModel) {},
            templateUrl: function(elem,attrs) {
                if (attrs.settingsType === 'filters') {
                    return 'dashboard/viewFields.html'
                } else {
                    return 'dashboard/viewFields-datasource.html'
                }
            },
        };
        return directiveDefinitionObject;
    }
]);
